import React, { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { Label, Icon } from '@nooz-optics/nooz-components-lib';
import { withLocale } from '../../../utils/hocs';
import { useMediaQuery } from '../../../utils/hooks/useMediaQuery';
import { zoneSwitcherState } from '../../../utils/recoil/zone';
import { Button } from '../../UI/Elements';
import { NativeSelect } from '../../UI/Forms/Inputs';

export const ZoneSwitcher = withLocale(({ label, button, zones, locale }) => {
  const [zoneSwitcher, setZoneSwitcher] = useRecoilState(zoneSwitcherState);
  const [open, setOpen] = useState(false);
  const [selectedZone, setSelectedZone] = useState(
    process.env.GATSBY_ZONE.toLowerCase()
  );
  const isWindowSmallSize = useMediaQuery('lg');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setOpen(!window.localStorage['zone-switcher']);
    }
  }, []);

  const handleCloseZoneSwitcher = () => {
    if (typeof window !== 'undefined') {
      setZoneSwitcher({ active: false });
      window.localStorage.setItem('zone-switcher', true);
    }
  };

  const handleClickZoneSwitcher = () => {
    if (typeof window !== 'undefined') {
      locale[2](selectedZone);
      window.localStorage.setItem('zone-switcher', true);
    }
  };

  const returnCloseZoneSwitcherButton = () => (
    <div className='ml-3'>
      <button
        type='button'
        onClick={handleCloseZoneSwitcher}
        className='flex justify-center items-center'>
        <Icon
          iconKey='MdClose'
          size='xl'
          color={{ classname: 'white' }}
        />
      </button>
    </div>
  );

  const returnZones = () =>
    zones?.values?.map((zone) => ({
      value: zone.value,
      label: zone.label,
    }));

  return zoneSwitcher.active && open ? (
    <div className='w-full flex items-center justify-center bg-gray-800'>
      <div className='bg-gray-800 main-wrapper flex items-center justify-center w-screen top-0'>
        <div className='py-4 w-full lg:flex'>
          <div className='w-full justify-between lg:w-2/3 flex lg:items-center lg:mr-3'>
            <Label
              {...label}
              color={{ classname: 'white' }}
              size='sm'
            />
            {isWindowSmallSize && returnCloseZoneSwitcherButton()}
          </div>
          <div className='flex items-center lg:w-1/3 mt-4 lg:mt-0 w-full'>
            <div className='bg-white w-full max-w-xs rounded-md'>
              <NativeSelect
                type='outlined'
                size='base'
                onChange={(e) => setSelectedZone(e.target.value)}
                selectedValue={selectedZone}
                values={returnZones()}
              />
            </div>
            <div className='ml-3'>
              <Button
                {...button}
                onClick={handleClickZoneSwitcher}
                size='base'
                type='contained'
                color={{ classname: 'white' }}
              />
            </div>
            {!isWindowSmallSize && returnCloseZoneSwitcherButton()}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
});
